import React from "react";
import { useNavigate } from "react-router-dom"; 
import goalsData from "../../../data/P1-EducationalGoals.json"; 
import GoalCard from "./GoalCard";

const EducationalGoals = () => {
  const navigate = useNavigate();

  const handleSelect = (goalId) => {
    navigate(`/angebot/${goalId}`);
  };

  return (
    <section className="py-3 mb-4" aria-labelledby="goals-title">
      <div className="container">
        <div className="text-center mb-3 p-4 pt-2 pb-2">
          <h2 id="goals-title" className="display-7 fw-bold text-gray-bbs">
            Deine Zukunft an den BBS 2 Leer
          </h2>
        </div>

        {/* 'role="list"' hilft Screenreadern, die Anzahl der Karten anzusagen */}
        <div className="row g-4 justify-content-center" role="list">
          {goalsData.map((goal) => (
            <div key={goal.id} className="col-12 col-md-6 col-lg-3 d-flex align-items-stretch" role="listitem">
              <GoalCard
                data={goal}
                onClick={() => handleSelect(goal.id)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationalGoals;